import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import Err from "../../../../routes/error";
import PersonalDetails from "@Shared/components/settings/account/personal-details";
import { UPDATE_ACCOUNT_PERSONAL_DETAILS, UPDATE_ACCOUNT_DETAILS } from "@Broker/@Modules/main/store/account/account-actions";
import { showToast } from "@Shared/utils/constants";
import { LOAD_FILOGIX_DETAILS } from "@Broker/@Modules/settings/store/settings-actions";
import { cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PersonalDetailsContainer",
  components: {
    PersonalDetails
  },
  props: {
    saving: {
      type: Boolean,
      required: true
    }
  },
  computed: _objectSpread({}, mapState("AccountStore", {
    userDetails(state) {
      return cloneDeep(state.userDetails);
    },
    accountDetails(state) {
      return cloneDeep(state.accountDetails);
    }
  })),
  watch: {
    saving(value) {
      if (!value) return;
      this.$refs.personalDetails.handleSubmit();
    }
  },
  mounted() {
    this.LOAD_FILOGIX_DETAILS();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("AccountStore", [UPDATE_ACCOUNT_PERSONAL_DETAILS, UPDATE_ACCOUNT_DETAILS])), mapActions("SettingsStore", [LOAD_FILOGIX_DETAILS])), {}, {
    async handleSubmit(userDetails) {
      try {
        const accountDetails = {
          timezone: userDetails.timezone
        };
        await this.UPDATE_ACCOUNT_PERSONAL_DETAILS({
          details: userDetails
        });
        await this.UPDATE_ACCOUNT_DETAILS({
          details: accountDetails
        });
        showToast("success", "personalDetailsUpdated");
        this.$emit("finish-saving", true);
      } catch (e) {
        this.$emit("finish-saving", false);
        Err.handle(e);
      }
    },
    handleAllowSave(allowSave) {
      this.$emit("allow-save", allowSave);
    }
  })
});